import { getHeroBackground } from 'utils/cms/utils';
import { getReleaseMessaging } from 'utils/releaseMessaging';
import { getDefaultButtons } from 'utils/homeButtons';

const pageIds = {
	tickets: 'boltShowtimes',
	homeEnt: 'boltHomeEnt',
	gallery: 'boltGallery',
	videos: 'boltVideos',
	synopsis: 'boltSynopsis'
};

function processButton(key, button) {
	const primary = key === 'button1';
	return { ...button, path: pageIds[button?.path] || button?.path, primary, order: key.replace('button', '') };
}

export default function mapHome(cmsData, appData) {
	if (!appData?.pages?.boltHome) return null;

	const homeData = cmsData?.pages?.home;
	if (!homeData) return {};
	if (homeData.heroMode === 'preview') return null;

	const isDefault = homeData?.settings?.default ?? true;
	const release = homeData.releaseMessaging;
	const defaultButtons = getDefaultButtons(cmsData);
	const button1 = processButton('button1', homeData.button1 || defaultButtons.button1);
	const button2 = processButton('button2', homeData.button2 || defaultButtons.button2);

	return {
		disabled: false,
		data: {
			bg: getHeroBackground(cmsData),
			btnLayout: homeData.btnLayout,
			button1: button1?.enabled ? button1 : null,
			button2: button2?.enabled ? button2 : null,
			textAboveButtons: (release?.enabled ?? true) ? (release?.text ?? getReleaseMessaging(cmsData)) : null,
			tt: { desktop: homeData.tt?.url, alt: homeData.tt?.alt },
		},
		isMainPage: isDefault,
		path: isDefault ? '/' : '/home/', // if not default, set to /home/ to ensure it doesn't take precedence over showtimes or homeEnt pages which may also be set to default
	};
}